import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";
import { useExperience } from "./useResumeData";

const pageTransitionVariants = {
  hidden: {
    x: "100vw",
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
    },
  },
  exit: {
    x: "-100vw",
    opacity: 0,
  },
};

const Experience = () => {
  const { experience, isLoading } = useExperience();

  return (
    <motion.div
      variants={pageTransitionVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="py-16"
    >
      <div className=" font-primary text-gray-500 dark:text-lightText text-center my-12 ">
        {/* <p className=" text-designColor opacity-95 mb-4">2020 - 2023</p> */}
        <h2 className=" text-3xl sm:text-4xl capitalize font-bold">
          Job Training & Experience
        </h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-16 gap-y-12  md:px-16">
        {isLoading ? (
          // Simple Skeleton
          [1, 2].map((i) => (
            <div key={i} className="animate-pulse rounded-lg bg-gray-200 p-10 dark:bg-[#1a1f2e] h-60"></div>
          ))
        ) : (
          experience?.map((item) => (
            <ResumeCard
              key={item.id}
              title={item.role}
              subTitle={`${item.company} (${item.year_range})`}
              result={item.location}
              desc={item.description}
            />
          ))
        )}
      </div>
    </motion.div>
  );
};

export default Experience;
